const initialState = () => ({
  nome: '',
  empresa: null,
  isAuthenticated: false,
  agendamentoExpress: false,
  urlLogo: '',
  colorTheme: '',
  enableTelemedicina: true,
  idWorkspace: true,
  idEmpresaFuncionario: ''
})

const state = initialState()

const mutations = {
  RESET: state => {
    Object.assign(state, initialState())
  },
  SET_IS_AUTHENTICATED: (state, payload) => {
    state.isAuthenticated = payload
  },
  SET_NOME: (state, nome) => {
    state.nome = nome
  },
  SET_EMPRESA: (state, empresa) => {
    state.empresa = empresa
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_AGENDAMENTO_EXPRESS: (state, agendamentoExpress) => {
    state.agendamentoExpress = agendamentoExpress
  },
  SET_URL_LOGO: (state, urlLogo) => {
    state.urlLogo = urlLogo
  },
  SET_COLOR_THEME: (state, colorTheme) => {
    state.colorTheme = colorTheme
  },
  SET_ENABLE_TELEMEDICINA: (state, enableTelemedicina) => {
    state.enableTelemedicina = enableTelemedicina
  },
  SET_ID_WORKSPACE: (state, idWorkspace) => {
    state.idWorkspace = idWorkspace
  },
  SET_ID_EMPRESA_FUNCIONARIO: (state, idEmpresaFuncionario) => {
    state.idEmpresaFuncionario = idEmpresaFuncionario
  }
}

const actions = {
  authenticateUser: ({ commit }, user) => {
    commit('SET_NOME', user.nome)
    commit('SET_EMPRESA', user.empresa)
    commit('SET_EMAIL', user.email)
    commit('SET_ID', user.id)
    commit('SET_IS_AUTHENTICATED', true)
    commit('SET_AGENDAMENTO_EXPRESS', user.agendamentoExpress)
    commit('SET_URL_LOGO', user.customizacao?.url_logo || require('@/assets/plataforma-limer-inverse.png'))
    commit('SET_COLOR_THEME', user.customizacao?.color_theme || '#055DFF')
    commit('SET_ENABLE_TELEMEDICINA', user.enableTelemedicina)
    commit('SET_ID_WORKSPACE', user.idWorkspace)
    commit('SET_ID_EMPRESA_FUNCIONARIO', user.idEmpresaFuncionario)
  },
  logoutUser: ({ commit }) => {
    commit('RESET')
    commit('SET_COLOR_THEME', '#00985E')
  }
}

const getters = {
  user: state => state,
  nome: state => state.nome,
  empresa: state => state.empresa,
  isAuthenticated: state => state.isAuthenticated,
  agendamentoExpress: state => state.agendamentoExpress,
  urlLogo: state => state.urlLogo,
  colorTheme: state => state.colorTheme,
  enableTelemedicina: state => state.enableTelemedicina,
  idWorkspace: state => state.idWorkspace,
  idEmpresaFuncionario: state => state.idEmpresaFuncionario,
  id: state => state.id
}

export default { namespaced: true, state, mutations, actions, getters }
